import React from "react";
import { FormField } from "../../../lib/utils/blueprintDataParser";
import { TabbedFileUploaderComponent } from "../editor/TabbedFileUploaderComponent";
import {
  TitleElement,
  TextAreaElement,
  NumberFieldElement,
  HyperLinkElement,
  TypesSelectionElement,
  GlossarySelectionElement,
  DialogSelectionElement
} from "./wizard-elements";
import { BooleanFieldElement } from "./wizard-elements/BooleanFieldElement";

export const getWizardElement = (
  field: FormField,
  value: any,
  onChange: (value: any) => void,
  onBlur?: (value: any) => void,
  gameId?: string,
) => {
  switch (field.type) {
    case 'boolean':
      return (
        <BooleanFieldElement
          id={field.id}
          checked={value}
          onChange={onChange}
          onBlur={onBlur}
        />
      );
    case "title":
      return (
        <TitleElement
          type="text"
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={field.placeholder}
        />
      );
    case 'textarea':
      return (
        <TextAreaElement
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={field.placeholder}
          rows={1}
          enableHighlighting={true}
        />
      );
    case 'number':
      return (
        <NumberFieldElement
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={field.placeholder}
          min={field.validation?.min}
          max={field.validation?.max}
          step={1}
        />
      );
    case 'file':
      return <TabbedFileUploaderComponent
        onFileChange={onChange}
        onLinkChange={onChange}
        onImageUpload={onChange}
        onClear={() => onChange(null)}
        onBlur={onBlur}
        accept={field.accept}
        placeholder={field.placeholder}
        uploadText={'Upload file'}
        linkPlaceholder={'Enter file link'}
        gameId={gameId}
        value={value}
      />;
    case 'image':
      return <TabbedFileUploaderComponent
        onFileChange={onChange}
        onLinkChange={onChange}
        onImageUpload={onChange}
        onClear={() => onChange(null)}
        onBlur={onBlur}
        accept="image/*"
        placeholder={field.placeholder}
        uploadText={'Upload image'}
        linkPlaceholder={'Enter image URL'}
        gameId={gameId}
        value={value}
      />;
    case 'url':
      return (
        <HyperLinkElement
          type="url"
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={field.placeholder}
        />
      );
    case 'types':
      return (
        <TypesSelectionElement
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={field.placeholder}
          multiple={field.multiple}
          filterOptions={field.filterOptions}
        />
      );
    case 'glossaryItem':
    case 'glossary-item':
      return (
        <GlossarySelectionElement
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={field.placeholder}
          multiple={field.multiple}
          filterOptions={field.filterOptions}
        />
      );
    case 'dialog':
      return (
        <DialogSelectionElement
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={field.placeholder}
          multiple={field.multiple}
          filterOptions={field.filterOptions}
        />
      );
    default:
      return (
        <TextAreaElement
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={field.placeholder}
          disabled={false}
          rows={1}
          enableHighlighting={true}
        />
      );
  }
};


